import React, { useState } from "react";
import "./../assets/css/modal.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { FaAccessibleIcon, FaFacebook, FaLinkedin, FaInstagram } from "react-icons/fa";
import AccessibilityModal from "./../components/AccessibilityModal";

const Contacto = () => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    nombre: "",
    apellido: "",
    correo: "",
    asunto: "",
    mensaje: ""
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: "", type: "" });

    try {
      const response = await fetch("https://habitatinclusion.com/apiweb/enviarcorreo.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.status === "success") {
        setMessage({ text: "El mensaje se envió correctamente", type: "success" });
        setFormData({
          nombre: "",
          apellido: "",
          correo: "",
          asunto: "",
          mensaje: ""
        });
      } else {
        setMessage({ text: data.message || "Error al enviar el mensaje", type: "error" });
      }
    } catch (error) {
      setMessage({ text: "Error de conexión", type: "error" });
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="micolor-jm">
      <Header />
       <button className="floating-button" onClick={toggleModal}>
        <img
          src={require("../assets/clientes/iconoaccesibilidad.jpg")}
          alt="Icono de accesibilidad"
          style={{ width: "30px", height: "30px" }}
        />
      </button>

      <AccessibilityModal isOpen={showModal} toggle={toggleModal} />

      <div className="container">
        <div className="row row-jm">
          <div className="col-md-6 col-sm-12 mt-5">
            <h2 className="mt-4 sobre-nosotras-title">CONTACTO</h2>
          </div>
          <div className="col-md-12 col-sm-12 mt-5"></div>
          <div className="col-md-6 col-sm-12 text-center">
            <img
              src={require("../assets/home/habitat33.jpg")}
              alt="Imagen vertical"
              className="img-vertical-nosotros"
            />
          </div>

          <div className="col-md-6 col-sm-12 mt-4 mb-5 text-center">
            <h4 className="mt-5"><strong>ESCRÍBENOS PARA MÁS INFORMACIÓN</strong></h4>
            {message.text && (
              <div className={`alert ${message.type === "success" ? "alert-success" : "alert-danger"}`}>
                {message.text}
              </div>
            )}
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id="nombre"
                  name="nombre"
                  placeholder="Nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  style={{ borderWidth: 3 }}
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id="apellido"
                  name="apellido"
                  placeholder="Apellido"
                  value={formData.apellido}
                  onChange={handleChange}
                  required
                  style={{ borderWidth: 3 }}
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  className="form-control"
                  id="correo"
                  name="correo"
                  placeholder="Correo"
                  value={formData.correo}
                  onChange={handleChange}
                  required
                  style={{ borderWidth: 3 }}
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id="asunto"
                  name="asunto"
                  placeholder="Asunto"
                  value={formData.asunto}
                  onChange={handleChange}
                  required
                  style={{ borderWidth: 3 }}
                />
              </div>
              <div className="form-group">
                <textarea
                  className="form-control"
                  id="mensaje"
                  name="mensaje"
                  rows="4"
                  placeholder="Mensaje"
                  value={formData.mensaje}
                  onChange={handleChange}
                  required
                  style={{ borderWidth: 3 }}
                ></textarea>
              </div>
              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Enviando..." : "Enviar"}
              </button>
              <h4 className="mt-4 text-left" style={{ fontWeight: 200 }}>También puedes escribirnos a través de nuestro correo o redes sociales</h4>
              <h4 className="text-left"><strong>habitatinclusion@gmail.com</strong></h4>

              <div className="social-icons mt-2 text-left">
                <a href="https://www.facebook.com/share/16r3xKPXUq/" target="_blank" rel="noopener noreferrer" className="mr-4">
                  <FaFacebook className="icon" style={{ fontSize: "30px", color: "#3b5998" }} />
                </a>
                <a href="https://www.linkedin.com/company/h%C3%A1bitat-inclusi%C3%B3n/" target="_blank" rel="noopener noreferrer" className="mr-4">
                  <FaLinkedin className="icon" style={{ fontSize: "30px", color: "#0077b5" }} />
                </a>
                <a href="https://www.instagram.com/habitat_inclusion?igsh=MWdhc21oem0yN2NmZA==" target="_blank" rel="noopener noreferrer">
                  <FaInstagram className="icon" style={{ fontSize: "30px", color: "#e4405f" }} />
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Contacto;